// Mel's speed change, 6 Oct 2026: load the RingCentral chat on the visitor's first interaction instead of on page load,
// the same as Roses Everywhere (assets/chat-widget-loader.js there, ticket #34391). Saves about 290 KB and its main-thread
// work during the first load. Keyboard users trigger it too (keydown).
function loadChatWidget() {
  if (window.chatWidgetLoaded) return;
  window.chatWidgetLoaded = true;

  var cm = document.createElement('script');
  cm.type = 'text/javascript';
  cm.async = true;
  cm.src = 'https://kcsafexvff.chat.digital.ringcentral.com/chat/f6b2a033e9ef4884a58cf253/loader.js';
  document.body.appendChild(cm);
}

['scroll', 'mousemove', 'touchstart', 'keydown'].forEach(function (type) {
  window.addEventListener(type, loadChatWidget, { once: true, passive: true });
});
